import { useGetCurrentUser } from "@/hooks/queries/useGetCurrentUser";
import { JOB_LINK_AUTHORIZED_EMAILS } from "@/lib/constants";

export const useCanLinkJobs = (): boolean => {
  const currentUser = useGetCurrentUser();
  return JOB_LINK_AUTHORIZED_EMAILS.includes(
    currentUser?.email.toLowerCase() ?? "",
  );
};
